import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import languagesJSON from "../../../assets/supportedLanguages.json";
import i18n from "../../../i18n";

type ModalLanguageProps = {
  closeModal: () => void;
};

const ModalLanguage: React.FC<ModalLanguageProps> = ({ closeModal }) => {
  const { t } = useTranslation();
  const [language, setLanguage] = useState<string>("en");
  const languages = useMemo(() => languagesJSON.languages, []);

  useEffect(() => {
    // set language from i18n
    setLanguage(i18n.language);
  }, []);

  const handleLanguageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const newLanguage = event.target.value;
    setLanguage(newLanguage);
    i18n.changeLanguage(newLanguage); // Change the i18n language dynamically
    closeModal();
    window.location.reload(); // Reload the page to apply the new language, must be done to new data from API
  };
  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <div className="modal-action">
          <label
            className="btn btn-circle btn-sm absolute right-2 top-2"
            onClick={closeModal}
          >
            ✕
          </label>
        </div>
        <h5 className="modal-title font-bold" id="modalLanguageSwitcherLabel">
          {t("Change Language")}
        </h5>
        <div className="py-4">
          {/* Dropdown using Tailwind and DaisyUI */}
          <select
            className="select select-bordered w-full"
            aria-label=""
            value={language}
            onChange={handleLanguageChange}
          >
            {languages.map((lang) => (
              <option key={lang.iso_code} value={lang.iso_code}>
                {lang.native_name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default ModalLanguage;
